<template>
  <ValidationObserver
    ref="obs"
    v-slot="{ passes }"
  >
    <v-form
      @submit.prevent="passes(null)"
    >
      <v-row>
        <v-col
          class="mb-0 py-0 mx-auto"
          cols="11"
          sm="10"
          md="5"
        >
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.tipo_documento')"
            :rules="validacionesFormulario.tipoDocumentoId"
            vid="tipoDocumentoId"
          >
            <v-autocomplete
              id="tipoDocumentoId"
              v-model="objtipoDocumentoId"
              :error-messages="errors"
              :label="$t('form.label.tipo_documento')"
              :items="tipoDocumentoIds"
              item-text="descripcion"
              item-value="id"
              background-color="white"
              name="tipoDocumentoId"
              filled
              return-object
              dense
              disabled
              outlined
              v-on="$listeners"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.numero_documento')"
            :rules="validacionesFormulario.numeroDocumento"
            vid="numeroDocumento"
          >
            <v-text-field
              id="numeroDocumento"
              v-model.trim="modelo.numeroDocumento"
              :error-messages="errors"
              :label="$t('form.label.numero_documento')"
              type="text"
              background-color="white"
              name="numeroDocumento"
              dense
              disabled
              outlined
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.nombre')"
            :rules="validacionesFormulario.nombre"
            vid="nombre"
          >
            <v-text-field
              id="nombre"
              v-model.trim="modelo.nombre"
              :error-messages="errors"
              :label="objtipoDocumentoId && objtipoDocumentoId.codigo === 'NIT' ? $t('form.label.razon_social') : $t('form.label.nombre')"
              type="text"
              background-color="white"
              name="nombre"
              dense
              disabled
              outlined
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.correo_electronico')"
            :rules="validacionesFormulario.correo"
            vid="correo"
          >
            <v-text-field
              id="correo"
              v-model.trim="modelo.correo"
              :error-messages="errors"
              :label="$t('form.label.correo_electronico')"
              type="text"
              background-color="white"
              name="correo"
              dense
              outlined
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.telefono')"
            :rules="validacionesFormulario.telefono"
            vid="telefono"
          >
            <v-text-field
              id="telefono"
              v-model.trim="modelo.telefono"
              :error-messages="errors"
              :label="$t('form.label.telefono')"
              type="text"
              background-color="white"
              name="telefono"
              dense
              outlined
              required
            />
          </ValidationProvider>
        </v-col>
        <v-col
          class="mb-0 py-0 mx-auto"
          cols="11"
          sm="10"
          md="5"
          offset-md="2"
        >
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.obra_id')"
            :rules="validacionesFormulario.obraId"
            vid="obraId"
          >
            <v-autocomplete
              id="obraId"
              v-model="objObra"
              :error-messages="errors"
              :label="$t('form.label.obra_id')"
              :items="obraIds"
              item-text="descripcion"
              item-value="id"
              background-color="white"
              name="obraId"
              filled
              return-object
              dense
              disabled
              outlined
              v-on="$listeners"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.tipo_moneda')"
            :rules="validacionesFormulario.tipoMoneda"
            vid="tipoMoneda"
          >
            <v-autocomplete
              id="tipoMoneda"
              v-model="modelo.tipoMoneda"
              :error-messages="errors"
              :label="$t('form.label.tipo_moneda')"
              :items="tiposDeMonedas"
              item-text="descripcion"
              item-value="id"
              background-color="white"
              name="tipoMoneda"
              filled
              dense
              disabled
              outlined
              v-on="$listeners"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.valor')"
            :rules="validacionesFormulario.valor"
            vid="valor"
          >
            <v-currency-field
              id="valor"
              v-model="modelo.valor"
              :error-messages="errors"
              :label="$t('form.label.valor')"
              type="text"
              background-color="white"
              name="valor"
              maxlength="16"
              dense
              disabled
              outlined
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('form.label.observaciones')"
            :rules="validacionesFormulario.observaciones"
            vid="observaciones"
          >
            <v-textarea
              id="observaciones"
              v-model="modelo.observaciones"
              :error-messages="errors"
              :label="$t('form.label.observaciones')"
              type="text"
              background-color="white"
              name="observaciones"
              rows="8"
              dense
              disabled
              outlined
              required
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :rules="validacionesFormulario.aceptaTerminosCondiciones"
            :name="$t('form.label.acepta_terminos_condiciones_label')"
            vid="aceptaTerminosCondiciones"
          >
            <v-checkbox
              id="aceptaTerminosCondiciones"
              v-model="modelo.aceptaTerminosCondiciones"
              :label="$t('form.label.acepta_terminos_condiciones')"
              :error-messages="errors"
              class="mt-0 required justify-center justify-sm-start"
              name="aceptaTerminosCondiciones"
              value="true"
            >
              <i18n
                slot="label"
                path="form.label.acepta_terminos_condiciones"
                tag="span"
              >
                <template v-slot:link>
                  <a
                    :href="objObra ? objObra.urlTerminosCondiciones : '#'"
                    target="_blank"
                    @click="abrirLinkTerminosCondiciones()"
                  >
                    Política de privacidad
                  </a>
                </template>
              </i18n>
            </v-checkbox>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :rules="validacionesFormulario.aceptaTratamientoDatos"
            :name="$t('form.label.acepta_tratamiento_datos_label')"
            vid="aceptaTratamientoDatos"
          >
            <v-checkbox
              id="aceptaTratamientoDatos"
              v-model="modelo.aceptaTratamientoDatos"
              :error-messages="errors"
              class="mt-0 justify-center justify-sm-start"
              name="aceptaTratamientoDatos"
              value="true"
            >
              <i18n
                slot="label"
                path="form.label.acepta_tratamiento_datos"
                tag="span"
              >
                <template v-slot:link>
                  <a
                    :href="objObra ? objObra.urlPoliticaTratamientoDatos : '#'"
                    target="_blank"
                    @click="abrirLink()"
                  >
                    {{ $t('form.label.link') }}
                  </a>
                </template>
              </i18n>
            </v-checkbox>
          </ValidationProvider>
          <input
            id="honeypot"
            name="honeypot"
            type="hidden"
            :value="modelo.honeypot"
          >
        </v-col>
      </v-row>
      <v-row>
        <botones-epayco
          :value="epaycoModel"
          :datos-obra="objObra"
          :validar-formulario="validarFormulario"
          deshabilitar-btn-agregador
        />
      </v-row>
      <!-- <v-row>
        <v-col class="d-flex justify-center  justify-sm-end">
          <v-btn
            large
            color="secondary"
            type="submit"
            dark
          >
            {{ $t('form.button.pagar') }}
          </v-btn>
        </v-col>
      </v-row> -->
    </v-form>
  </ValidationObserver>
</template>

<script>
import handleErrorMixin from '../../../../../../../mixins/handleErrorMixin'
import recaptchaV3Mixin from '../../../../../../../mixins/recaptchaV3Mixin'
import validacionesFormulario from './data/formularioReferenciaValidations'
import generalParametersMixin from '@/mixins/generalParametersMixin'
import {
  PAGAR_REFERENCIA,
  FIELDS_DEFAULT_EPAYCO_CHECKOUT,
  SERVICIO_PASARELA_PAGO_CODIGO,
  WEBHOOK_CONFIRMACION_EPAYCO,
  URL_RESPONSE_EPAYCO
} from './data/formularioReferenciaConstants'
import { SHOW_ALERT } from '../../../../../../../store/mutations-types'
import { BAD_REQUEST, NOT_FOUND } from '../../../../../../../shared/constants/httpStatus'
import { mapState } from 'vuex'
import BotonesEpayco from '@/components/uiComponents/pasarelasPagos/botonesEpayco/BotonesEpayco'

export default {
  name: 'FormularioReferencia',
  components: {
    BotonesEpayco
  },
  mixins: [ handleErrorMixin, recaptchaV3Mixin, generalParametersMixin ],
  props: {
    tipoDocumentoIds: {
      type: Array,
      default: () => {},
      description: 'Contiene todos los tipos de docuemntos a mostrar en la lista desplegable'
    },
    obraIds: {
      type: Array,
      default: () => {},
      description: 'Contiene todas las obras a mostrar en la lista desplegable'
    },
    tiposDeMonedas: {
      type: Array,
      default: () => {},
      description: 'Contiene todas las obras a mostrar en la lista desplegable'
    }
  },
  data () {
    return {
      modelo: {
        tipoDocumentoId: null,
        numeroDocumento: null,
        nombre: null,
        correo: null,
        telefono: null,
        obraId: null,
        tipoMoneda: null,
        valor: null,
        observaciones: null,
        aceptaTratamientoDatos: null,
        honeypot: ''
      },
      referencia: null,
      deshabilitarBoton: false,
      tipoPago: true,
      date: null,
      objtipoDocumentoId: null,
      objObra: null,
      validacionesFormulario: validacionesFormulario
    }
  },
  computed: {
    ...mapState(['configColor']),
    epaycoModel () {
      return {
        // Parametros compra (obligatorio)
        name: 'PAGO EN LINEA',
        description: `PAGO EN LINEA: ${this.modelo.observaciones}`,
        invoice: this.referencia,
        currency: this.modelo.tipoMoneda,
        amount: this.modelo.valor,
        tax_base: this.modelo.valor,
        tax: FIELDS_DEFAULT_EPAYCO_CHECKOUT.SIN_IVA,
        country: 'CO',
        lang: this.changeLanguage,
        // Onpage='false' - Standard='true'
        external: FIELDS_DEFAULT_EPAYCO_CHECKOUT.EXTERNAL_CHECKOUT,
        // Atributos opcionales
        extra1: SERVICIO_PASARELA_PAGO_CODIGO,
        extra2: JSON.stringify(this.modelo),
        extra3: undefined,
        confirmation: WEBHOOK_CONFIRMACION_EPAYCO,
        response: URL_RESPONSE_EPAYCO,
        // Atributos cliente
        name_billing: this.modelo.nombre,
        address_billing: this.modelo.direccion,
        type_doc_billing: this.objtipoDocumentoId ? this.objtipoDocumentoId.codigo.toLowerCase() : null,
        mobilephone_billing: this.modelo.telefono,
        number_doc_billing: this.modelo.numeroDocumento,
        email_billing: this.modelo.correo
        // atributo deshabilitación metodo de pago
        // methodsDisable: ['TDC', 'PSE', 'SP', 'CASH', 'DP']
      }
    }
  },
  watch: {
    /**
     * This watcher set value of username to email for the moment
     *
     * @author Andres Correa
     * @version 1.0.0
     * @since 03/08/2020
     */
    objObra (newValue) {
      this.modelo.obraId = newValue ? newValue.id : null
      if (newValue && newValue.descripcion) {
        this.$_generalParametersMixin_update(newValue.colorPrincipal, newValue.colorSecundario, newValue.urlLogo)
      } else {
        this.$_generalParametersMixin_update(this.configColor.primary, this.configColor.secondary, this.generalParametersUrlLogo)
      }
    },
    objtipoDocumentoId (tipoDocumento) {
      this.modelo.tipoDocumentoId = tipoDocumento ? tipoDocumento.id : null
    }
  },
  methods: {
    async validarFormulario () {
      return await this.$refs.obs.validate() && this.modelo.honeypot === '' && this.$_recaptchaV3Mixin_validate()
    },
    /**
   * Metodo para abrir link de habeas data
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    abrirLink () {
      window.open(this.objObra ? this.objObra.urlPoliticaTratamientoDatos : '#')
    },
    /**
   * Metodo para mostrar modal de terminos y condiciones.
   *
   * @author Valentin Agudelo Aquite
   * @version 1.0.0
   * @since 20/02/2020 06:24 PM
   */
    abrirLinkTerminosCondiciones () {
      window.open(this.objObra ? this.objObra.urlTerminosCondiciones : '#')
    },
    llenarFormulario (data) {
      if (data) {
        this.referencia = data.numeroReferencia
        this.objtipoDocumentoId = data.tipoDocumento
        this.objObra = data.obra
        this.modelo.tipoDocumentoId = null
        this.modelo.numeroDocumento = data.numeroDocumento
        this.modelo.nombre = data.nombre
        this.modelo.correo = data.correo
        this.modelo.telefono = data.telefono
        this.modelo.obraId = null
        this.modelo.tipoMoneda = data.tipoMoneda
        this.modelo.valor = data.valor
        this.modelo.observaciones = data.observaciones
        this.modelo.aceptaTratamientoDatos = null
      } else {
        this.referencia = null
        this.objtipoDocumentoId = null
        this.objObra = null
        this.modelo.tipoDocumentoId = null
        this.modelo.numeroDocumento = null
        this.modelo.fechaCumpleanhos = null
        this.modelo.nombre = null
        this.modelo.correo = null
        this.modelo.telefono = null
        this.modelo.obraId = null
        this.modelo.tipoMoneda = null
        this.modelo.valor = null
        this.modelo.observaciones = null
        this.modelo.aceptaTratamientoDatos = null
      }
    },
    async pagarPorReferencia () {
      if (this.modelo.honeypot === '' && await this.$_recaptchaV3Mixin_validate()) {
        this.modelo.tipoDocumentoId = this.objtipoDocumentoId.id
        this.modelo.obraId = this.objObra.id
        this.axios.put(`${PAGAR_REFERENCIA}${this.referencia}`, this.modelo).then((response) => {
          window.location = response.data
        }).catch(error => {
          if (error.response.status === BAD_REQUEST) {
            this.$store.commit(SHOW_ALERT, {
              show: true,
              text: error.response.data.mensajeError,
              type: 'warning'
            })
          } else if (error.response.status === NOT_FOUND) {
            this.$store.commit(SHOW_ALERT, {
              type: 'warning',
              show: true,
              text: this.$t('error.404')
            })
          } else {
            this.$_handleErrorMixin_generateError(error)
          }
        })
      } else {
        this.$store.commit(SHOW_ALERT, {
          type: 'error',
          text: this.$t('error_message.internal_server'),
          show: true
        })
      }
    }
  }
}
</script>

<style>

</style>

<i18n>
{
  "es": {
    "form": {
      "label": {
        "numero_documento": "Número de documento",
        "tipo_documento": "Tipo de documento",
        "numero_referencia": "Número de referencia",
        "numero_identificacion": "Número de identificación",
        "nombre": "Nombre Completo",
        "razon_social": "Razón social",
        "correo_electronico": "Correo electrónico",
        "telefono": "Teléfono",
        "obra_id": "Obra",
        "tipo_moneda": "Tipo de Moneda",
        "valor": "Valor",
        "observaciones": "Observaciones",
        "acepta_terminos_condiciones_label": "He leído, entendido y aceptado los términos y condiciones",
        "acepta_terminos_condiciones": "He leído, entendido y aceptado los términos y condiciones, {link}",
        "acepta_tratamiento_datos_label": "Acepto que utilicen mis datos para enviarme información de la Organización VID",
        "acepta_tratamiento_datos": "Acepto que utilicen mis datos para enviarme información de la Organización VID {link}",
        "link": "Tratamiento de datos"
      },
      "button": {
        "pagar": "PAGAR"
      }
    },
    "pagar_referenica": "Pago realizado correctamente",
    "error": {
      "400": "La referencia ya fue pagada",
      "404": "El pago relacionado a esa referencia no existe"
    }
  }
}
</i18n>
